module.exports = __webpack_public_path__ + "media/images/game_icon/en/VGROULETTE-6331716a00e74f7c038e1333b453d294.png";